// extracted by mini-css-extract-plugin
export var addToCartButton = "_mz-b";
export var arrowButtonContainer = "_mz-9";
export var arrowButtonIcon = "_mz-a";
export var carouselArrowButton = "_mz-6";
export var carouselElementContainer = "_mz-1";
export var left = "_mz-7";
export var productDisplayCarouselContainer = "_mz-0";
export var productTileContainer = "_mz-2";
export var productTileImage = "_mz-4";
export var productTileImageContainer = "_mz-3";
export var productTileTitle = "_mz-5";
export var right = "_mz-8";
export var sliderOverflow = "_mz-c";